import { Icon as IconComponent } from "./Icon";

export const Icon = Object.assign(IconComponent, {});